import { useContext } from 'react'

import {
  Button, ModalContext, SectionDivider, SidebarModal,
} from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'
import useFlipperKey from '@hooks/useFlipperKey'

import IntegrationPlatform from './components/IntegrationPlatform'

const MODAL_KEY = 'SelectIntegrationPlatformModal'

type ModalPayload = {
  agency: AgencyModel,
}

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const SelectIntegrationPlatformModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload: ModalPayload = modalData?.[MODAL_KEY] ?? {}
  const { agency } = modalPayload

  const { isEnabled: isCanvaEnabled } = useFlipperKey('canva_integration')

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Select" titleSecondLine="Platform " />

      <SidebarModal.Content hasFooter={false}>

        <SectionDivider boxProps={{ marginBottom: 'medium', flexShrink: 0 }}>
          PLATFORMS
        </SectionDivider>

        <IntegrationPlatform
          integrationTitle="My Property Pass"
          integrationKey="my_property_pass"
          agency={agency}
        />

        { isCanvaEnabled && (
          <IntegrationPlatform
            integrationTitle="Canva"
            integrationKey="canva"
            agency={agency}
          />
        )}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          onClick={() => closeModal()}
          size="large"
        >
          Close Modal
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <SelectIntegrationPlatformModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
